import Environment from '../../Environment';

export default {
  appName: 'omni',
  // Environment is undefined in web-app during server side rendering (SSR) and some contexts in the web-app
  url: Environment?.unleashService ?? '',
  clientKey: Environment?.unleashClientKey ?? '',
};
